import { Box } from "@chakra-ui/react";
import { LandlordTenantPortalPropertyBannerDetails } from "components/property-banner-image/landlord-tenant-portal-property-banner-details";
import { getGreeting } from "components/property-banner-image/property-banner-details";
import { useAuth } from "contexts/auth-provider";
import { DisplayBannerImage } from "modules/landlord-portal/components/display-banner-image";
import { PropertyCountNumbers } from "modules/landlord-portal/components/property-count-numbers";
import type { FinancialsOverviewData } from "modules/landlord-portal/models/financials";
import type { TenancyAgreementSummaryData } from "modules/landlord-portal/models/overview";
import { FinancialSnapshotBox } from "modules/landlord-portal/screens/financial/components/banner-image/financial-snapshot-box";

type LandlordBannerImageProps = {
  isLoading: boolean;
  propertySummary?: TenancyAgreementSummaryData;
  financialSnapshot?: FinancialsOverviewData["financial_snapshot"];
};

export function LandlordFinancialsBannerImage({
  isLoading,
  propertySummary,
  financialSnapshot,
}: LandlordBannerImageProps) {
  const { user } = useAuth();
  const currentHour = new Date().getHours();
  const greeting = getGreeting(currentHour);

  return (
    <LandlordTenantPortalPropertyBannerDetails
      isLoading={isLoading}
      title={`${greeting}, ${user?.given_name}!`}
      topLeftElement={<DisplayBannerImage user={user} />}
      subtitle={<PropertyCountNumbers propertySummary={propertySummary} />}
      rightElement={
        <Box alignSelf={"stretch"} flex={1} flexBasis={{ base: "100%", xl: 0 }}>
          <FinancialSnapshotBox
            isLoading={isLoading}
            summary={financialSnapshot}
          />
        </Box>
      }
    />
  );
}
